<template>
  <div>
    <h1 class="display-1 primary--text">
      {{ $t('message.users') }}
    </h1>
    <p>{{ $t('message.row_click_for_details') }}</p>
    <v-data-table
      v-if="users"
      :headers="headers"
      :items="users"
      class="elevation-1"
      :total-items="users.total"
      :pagination.sync="pagination"
      :must-sort="true"
      :rows-per-page-items="[50, 100, 200]"
      item-key="email"
    >
      <template v-slot:items="row">
        <tr @click="row.expanded = !row.expanded">
          <td>
            <v-icon
              v-if="row.item.active"
              color="success"
            >
              fa-check
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              fa-ban
            </v-icon>
          </td>
          <td>{{ row.item.first_name }}</td>
          <td>{{ row.item.insertion }}</td>
          <td>{{ row.item.last_name }}</td>
          <td>{{ row.item.email }}</td>
          <td>{{ $t('message.user_role_' + row.item.role) }}</td>
          <td>{{ new Date(row.item.createdAt).toLocaleString() }}</td>
        </tr>
      </template>

      <template v-slot:expand="row">
        <user-info
          :user="row.item"
          :editable="true"
          @editUser="showUserEditDialog"
        />
      </template>
    </v-data-table>
    <user-role-and-subscription-dialog
      v-model="userEditDialogVisible"
      :user="editedUser"
      @confirm="saveUser"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import UserInfo from '../admin/UserInfo'
import UserRoleAndSubscriptionDialog from '@/components/admin/UserRoleAndSubscriptionDialog'
import isEmpty from 'lodash/isEmpty'

export default {
  components: { UserInfo, UserRoleAndSubscriptionDialog },
  data: (vm) => ({
    editedUser: {},
    headers: [
      { text: vm.$t('message.is_user_active'), value: 'active' },
      { text: vm.$t('message.first_name'), value: 'first_name' },
      { text: vm.$t('message.insertion'), value: 'insertion' },
      { text: vm.$t('message.last_name'), value: 'last_name' },
      { text: vm.$t('message.email'), value: 'email' },
      { text: vm.$t('message.user_role'), value: 'role' },
      { text: vm.$t('message.created'), value: 'createdAt' },
    ],
    pagination: {
      rowsPerPage: 100,
      sortBy: 'createdAt',
      descending: true,
    },
  }),
  computed: {
    ...mapState(['users']),
    userEditDialogVisible: {
      get() {
        return !isEmpty(this.editedUser)
      },
      set(value) {
        if (!value) this.editedUser = {}
      },
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getUsers()
      },
      deep: true,
    },
  },
  created() {
    this.$store.subscribe((mutation) => {
      switch (mutation.type) {
      case 'onUserUpdated':
        this.getUsers()
        break
      }
    })
  },
  mounted() {
    if (this.users.length === 0) {
      this.getUsers()
    }
  },
  methods: {
    getUsers() {
      this.$store.dispatch('getUsers', {
        query: {
          $skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          $limit: this.pagination.rowsPerPage,
          $sort: {
            [this.pagination.sortBy]: this.pagination.descending ? -1 : 1,
          },
        },
      })
    },
    updateUser(user) {
      this.updateUserDialog = false
    },
    showUserEditDialog(user) {
      this.editedUser = Object.assign({}, user)
    },
    saveUser(user) {
      this.userEditDialogVisible = false
      this.$store.dispatch('updateUserProfile', user)
    },
  },
}
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
